export const server = "https://bismosimprimerie.vercel.app/api/v2";
export const backend_url = "https://bismosimprimerie.vercel.app";

//export const server = "http://localhost:9000/api/v2";
//export const backend_url = "http://localhost:9000";
export const nif = "4002701698";
export const rccm = "0058712/24";
